import config, { PluginConfig } from './config'
import { VueConstructor } from 'vue'
import * as components from './components'

const GlpUI = {
  install (Vue: VueConstructor, args?: Partial<PluginConfig>) {
    if (args) {
      Object.assign(config, args)
    }
    Object.entries(components).forEach(([key, component]) => {
      Vue.component(key, component as VueConstructor)
    })
  },
  version: process.env.VERSION
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(GlpUI)
}

export default GlpUI
